/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalsignin_Email_LabelInputs */

const en_portalsignin_email_label = /** @type {(inputs: Portalsignin_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email address`)
};

/** @type {(inputs: Portalsignin_Email_LabelInputs) => LocalizedString} */
const ar_portalsignin_email_label = en_portalsignin_email_label;

/** @type {(inputs: Portalsignin_Email_LabelInputs) => LocalizedString} */
const he_portalsignin_email_label = en_portalsignin_email_label;

/** @type {(inputs: Portalsignin_Email_LabelInputs) => LocalizedString} */
const ur_portalsignin_email_label = en_portalsignin_email_label;

/** @type {(inputs: Portalsignin_Email_LabelInputs) => LocalizedString} */
const es_portalsignin_email_label = en_portalsignin_email_label;

/** @type {(inputs: Portalsignin_Email_LabelInputs) => LocalizedString} */
const fr_portalsignin_email_label = en_portalsignin_email_label;

/** @type {(inputs: Portalsignin_Email_LabelInputs) => LocalizedString} */
const de_portalsignin_email_label = en_portalsignin_email_label;

/** @type {(inputs: Portalsignin_Email_LabelInputs) => LocalizedString} */
const pt_portalsignin_email_label = en_portalsignin_email_label;

/** @type {(inputs: Portalsignin_Email_LabelInputs) => LocalizedString} */
const hi_portalsignin_email_label = en_portalsignin_email_label;

/** @type {(inputs: Portalsignin_Email_LabelInputs) => LocalizedString} */
const bn_portalsignin_email_label = en_portalsignin_email_label;

/**
* | output |
* | --- |
* | "Email address" |
*
* @param {Portalsignin_Email_LabelInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalsignin_email_label = /** @type {((inputs?: Portalsignin_Email_LabelInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalsignin_Email_LabelInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalsignin_email_label(inputs)
	if (locale === "he") return he_portalsignin_email_label(inputs)
	if (locale === "ur") return ur_portalsignin_email_label(inputs)
	if (locale === "es") return es_portalsignin_email_label(inputs)
	if (locale === "fr") return fr_portalsignin_email_label(inputs)
	if (locale === "de") return de_portalsignin_email_label(inputs)
	if (locale === "pt") return pt_portalsignin_email_label(inputs)
	if (locale === "hi") return hi_portalsignin_email_label(inputs)
	if (locale === "bn") return bn_portalsignin_email_label(inputs)
	return /** @type {LocalizedString} */ ("Email address")
});